/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
    Card,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from "react-router-dom";
import { addInvoicePdfFormat, getInvoicePdfFormatById, updateInvoicePdfFormatData } from "utils/api";
import { validateField } from "utils/generic";
import { showResMsg } from "utils/generic";
import { getScreenRight } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import PageTitle from "examples/PageTitle/PageTitle";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import swal from 'sweetalert';
import { getUserProfileByID } from "utils/api";

const errMsg = {
    color: `red`,
    fontSize: `11px`,
};


let fetchedInvoicePdfFormat;
const SCREEN_NAME = "Roles";
let SCREEN_RIGHT = "None";
let routePath = "";


let LOGIN_DETAILS;
function AddInvoicePdfFormat() {
    const { id } = useParams();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [screenName, setScreenName] = useState("Add Invoice Theme Configuration (PDF Format)");
    const [themeNameErr, setThemeNameErr] = useState(false);
    const [fontStyleErr, setFontStyleErr] = useState(false);
    const [fontSizeErr, setFontSizeErr] = useState(false);
    const [contactDetailsErr, setContactDetailsErr] = useState(false);
    const [values, setValues] = useState({
        themeName: "",
        fontStyle: "1",
        fontSize: "10",
        logoAlignment: "2",
        contactDetails: "",
        defaultTheme: true,
        showTaxNumber: false,
        showColHead: false,
        showItemCode: false,
        showPriceQuantity: false,
        showPaymentAdvice: false,
        showTaxColumn: false,
        showRegdAddress: false,
        showLogo: false,
        hideDiscount: false,
        showAccNumber: false,
        termsAndPaymentAdvice: "",

    });


    const [controller] = useMaterialUIController();
    const { sidenavColor, darkMode } = controller;
    async function getRight() {
        SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
    }


    const handleChange = (name) => (event) => {
        if (name === "themeName") {
            setThemeNameErr(false);

        }
        if (name === "fontStyle") {
            setFontStyleErr(false);
        }
        if (name === "fontSize") {
            setFontSizeErr(false);

        }
        if (name === "contactDetails") {
            setContactDetailsErr(false);
        }
        const newValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        setValues({ ...values, [name]: newValue });
    };;
    const { barColor, tableBorder } = getColorMappings(sidenavColor);

    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
    values.businessUserID = LOGIN_DETAILS.businessUserID;

    const getUserProfile = async () => {
        await getUserProfileByID({ _id: JSON.parse(sessionStorage.getItem("USER_ID")) }, (data) => {
            if (data.Result_Output.length > 0) {
                values.contactDetails = `${data.Result_Output[0].companyName}, \n${data.Result_Output[0].streetAddress}, ${data.Result_Output[0].stateName}, ${data.Result_Output[0].countryName}, ${data.Result_Output[0].zipCode},`
            }
        }, dispatch)
    };

    useEffect(() => {

        const paramValue = new URLSearchParams(window.location.search).get('new');
        const ref = new URLSearchParams(window.location.search).get("ref");
        const urlID = new URLSearchParams(window.location.search).get("id");
        switch (paramValue) {
            case "invoice":
                routePath = `/invoices/invoice/${ref}/${urlID}`;
                break;
            case "contacts":
                routePath = '/contacts';
                break;
            default:
                routePath = '/invoicePdfFormat';
                break;
        }
        id === undefined ? setScreenName("Add Invoice Theme Configuration(PDF Format)") : setScreenName("Edit Invoice Theme Configuration (PDF Format)");

        (async () => {
            getRight();
            if (id !== undefined) {
                values._id = id
                console.log(values._id)
                getInvoicePdfFormatById({ _id: id }, (data) => {
                    if (data.Result_Output.length > 0) {
                        fetchedInvoicePdfFormat = data.Result_Output[0];
                        setValues(fetchedInvoicePdfFormat);
                    }
                }, dispatch)
            } else {
                await getUserProfile();
            }
        }
        )();
    }, [dispatch])

    const SaveInvoicePdfFormat = async () => {
        if (values.defaultTheme) {
            swal({
                title: `Do you want to set this Theme as default?`, customClass: "swal-modal swal-title", text: ``,
                closeOnClickOutside: false, closeOnEsc: false, buttons: {
                    cancel: {
                        text: "No", value: false, visible: true, className: "btn-block center-container-btn btn-warning no-button", closeModal: true,
                    },
                    confirm: {
                        text: "Yes", value: true, visible: true, className: "btn-block center-container-btn btn-success yes-button", closeModal: true
                    }
                }
            }).then((value) => {
                if (value) {
                    addUpdate()
                }


            })
                .catch(error => {
                    console.log("Error in swal");
                });

        } else {
            addUpdate()

        }

    }


    const addUpdate = () => {
        try {
            let mandateFlag = false;
            clearErrorStates();
            mandateFlag = validateField(values.themeName, setThemeNameErr) || mandateFlag;
            mandateFlag = validateField(values.fontStyle, setFontStyleErr) || mandateFlag;
            mandateFlag = validateField(values.fontSize, setFontSizeErr) || mandateFlag;
            mandateFlag = validateField(values.contactDetails, setContactDetailsErr) || mandateFlag;
            if (mandateFlag) {
                return;
            }
            const apiFunction = id === undefined ? addInvoicePdfFormat : updateInvoicePdfFormatData;
            apiFunction(values, (data) => {
                if (data.Result_Status) {
                    showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
                } else {
                    showResMsg(data.Result_Message, 2000, data.Result_Status);
                }
            }, dispatch);
        } catch (errr) {


        }
    }

    const clearErrorStates = () => {
        setThemeNameErr(false);
        setFontStyleErr(false);
        setFontSizeErr(false);
        setContactDetailsErr(false);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div style={{ marginTop: "20px" }}>
                <Card sx={{ boxShadow: "none" }}>
                    <PageTitle screenName={screenName} />
                    <MDBox mt={2} mb={3}>
                        <Grid container spacing={1} sx={{ display: "flex", justifyContent: "center" }}>
                            <Grid item xs={12} spacing={12}>
                                {/* <Card sx={{ boxShadow: "none" }}>
                            <MDBox
                                mx={2}
                                mt={-3}
                                mb={1.5}
                                py={2}
                                px={2}
                                variant="gradient"
                                bgColor={sidenavColor}
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    {screenName}
                                </MDTypography>
                            </MDBox> */}
                                <MDBox
                                    pt={6} pb={3} mt={-5}>
                                    <Grid container
                                        p={2}
                                        columnSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
                                        rowSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}>

                                        <Grid item lg={6} xs={12} >
                                            <Grid item lg={10} xs={12} mb={2}>
                                                <TextField
                                                    type="text"
                                                    label="Theme Name"
                                                    variant="outlined"
                                                    placeholder="Theme Name"
                                                    fullWidth
                                                    inputProps={{
                                                        maxLength: 30,
                                                        pattern: "^[a-zA-Z0-9 ]+$",
                                                        className: "custom-fieldtext"

                                                    }}
                                                    value={values.themeName}
                                                    onChange={handleChange('themeName')}
                                                    autoFocus={true}
                                                />
                                                {themeNameErr ? <span style={errMsg}>Theme Name can't be blank</span> : ""}
                                            </Grid>

                                            <Grid item lg={10} xs={12} mb={2}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Font Style</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        style={{ height: "35.11px" }}
                                                        label="Font Style"
                                                        value={values.fontStyle}
                                                        onChange={handleChange('fontStyle')}
                                                    >
                                                        <MenuItem value="1">SansSerif</MenuItem>
                                                        <MenuItem value="2">DejaVu Sans Mono</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                {fontStyleErr ? <span style={errMsg}>Font Style can't be blank</span> : ""}
                                            </Grid>
                                            <Grid item py={2} lg={10} xs={12}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Font Size</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        style={{ height: "35.11px" }}
                                                        label="Font Size"
                                                        value={values.fontSize}
                                                        onChange={handleChange('fontSize')}
                                                    >
                                                        <MenuItem value="8">8pt</MenuItem>
                                                        <MenuItem value="9">9pt</MenuItem>
                                                        <MenuItem value="10">10pt</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                {fontSizeErr ? <span style={errMsg}>Font Size can't be blank</span> : ""}
                                            </Grid>
                                            <Grid item lg={10} xs={12}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Default theme</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        style={{ height: "35.11px" }}
                                                        label="Default theme"
                                                        value={values.defaultTheme}
                                                        onChange={handleChange('defaultTheme')}
                                                    >
                                                        <MenuItem value={true}>Yes</MenuItem>
                                                        <MenuItem value={false}>No</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item lg={6} mt={6}>
                                                <FormControl>
                                                    <FormLabel style={{ fontSize: "14px", fontWeight: "bold" }} className={darkMode ? "whiteLabel" : "blackLabel"} id="demo-radio-buttons-group-label">Business Logo Alignment</FormLabel>
                                                    <RadioGroup
                                                        aria-labelledby="demo-radio-buttons-group-label"
                                                        name="radio-buttons-group"
                                                        value={values.logoAlignment}
                                                        onChange={handleChange('logoAlignment')}
                                                    >
                                                        <FormControlLabel value="1" control={<Radio />} label="Left" />
                                                        <FormControlLabel value="2" control={<Radio />} label="Center" />
                                                        <FormControlLabel value="3" control={<Radio />} label="Right" />
                                                    </RadioGroup>
                                                </FormControl>
                                                <Grid item lg={12} >
                                                    <Typography style={{ fontSize: "14px", fontWeight: "bold" }} className={darkMode ? "whiteLabel" : "blackLabel"} >Business Name & Address</Typography>
                                                    <textarea
                                                        rows={8}
                                                        style={{
                                                            width: "100%", cursor: "text", borderColor: tableBorder, outline: "none"
                                                        }}
                                                        aria-label="maximum height"
                                                        value={values.contactDetails}
                                                        onChange={handleChange('contactDetails')}

                                                        className={darkMode ? "blackLabel1" : "whiteLabel1"}

                                                    />
                                                    {contactDetailsErr ? <span style={errMsg}>Business Name & Address can't be blank</span> : ""}
                                                </Grid>
                                            </Grid>

                                        </Grid>
                                        <Grid container item lg={6} xs={4} >
                                            <Grid item lg={6} mt={-1.2}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox name="taxNumber" />
                                                    }
                                                    label="Show Tax Number"
                                                    checked={values.showTaxNumber}
                                                    onChange={handleChange("showTaxNumber")}
                                                />


                                                <FormControlLabel
                                                    control={
                                                        <Checkbox name="colHead" />
                                                    }
                                                    label="Show Column Headings"
                                                    checked={values.showColHead}
                                                    onChange={handleChange("showColHead")}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox name="itemCode" />
                                                    }
                                                    label="Show Item Code"
                                                    checked={values.showItemCode}
                                                    onChange={handleChange("showItemCode")}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox name="priceQuantity" />
                                                    }
                                                    label="Show Unit Price & Quantity"
                                                    checked={values.showPriceQuantity}
                                                    onChange={handleChange("showPriceQuantity")}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox name="taxColumn" />
                                                    }
                                                    label="Show Tax Column"
                                                    checked={values.showTaxColumn}
                                                    onChange={handleChange("showTaxColumn")}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox name="regdAddress" />
                                                    }
                                                    label="Show Registered Address"
                                                    checked={values.showRegdAddress}
                                                    onChange={handleChange("showRegdAddress")}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox name="logo" />
                                                    }
                                                    label="Show Logo"
                                                    checked={values.showLogo}
                                                    onChange={handleChange("showLogo")}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox name="hideDiscount" />
                                                    }
                                                    label="Hide Discount"
                                                    checked={values.hideDiscount}
                                                    onChange={handleChange("hideDiscount")}
                                                />
                                                {/* <FormControlLabel
                                                control={
                                                    <Checkbox name="accNumber" />
                                                }
                                                label="Show Contact Account Number"
                                                checked={values.showAccNumber}
                                                onChange={handleChange("showAccNumber")}
                                            /> */}

                                            </Grid>


                                            <Grid item lg={12} pt={2}>
                                                <Typography style={{ fontSize: "14px", fontWeight: "bold" }} className={darkMode ? "whiteLabel" : "blackLabel"} >Standard Terms & Conditions</Typography>
                                                <textarea
                                                    rows={8}
                                                    style={{ width: "100%", height: "130px", borderColor: tableBorder, outline: tableBorder }}
                                                    aria-label="maximum height"
                                                    value={values.termsAndPaymentAdvice}
                                                    onChange={handleChange('termsAndPaymentAdvice')}
                                                    className={darkMode ? "blackLabel1" : "whiteLabel1"}
                                                />


                                            </Grid>

                                        </Grid>
                                    </Grid>

                                    <Grid
                                        container
                                        mt={2}
                                        // columnSpacing={{ xs: 2, md: 4, lg: 4 }}
                                        // columnSpacing={4}
                                        spacing={2}
                                        style={{ display: "flex", justifyContent: "center" }}
                                        className="gridbuttons"
                                    >
                                        <Grid item xs={12} md={4} spacing={2} lg={1.701}>
                                            <Link to={routePath}>
                                                <MDButton
                                                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                                                    color="warning"
                                                    fullWidth
                                                    style={{ height: "40px" }}
                                                >
                                                    Close
                                                </MDButton>
                                            </Link>
                                        </Grid>
                                        <Grid item xs={12} md={4} spacing={2} lg={1.701}>
                                            <MDButton rel="noreferrer" variant="gradient" color="success" fullWidth onClick={SaveInvoicePdfFormat} style={{ height: "40px" }}>
                                                {id ? "Update" : "Save"}
                                            </MDButton>
                                        </Grid>
                                    </Grid>
                                </MDBox>
                                {/* </Card> */}
                            </Grid>
                        </Grid>


                    </MDBox>
                </Card>
            </div>
        </DashboardLayout>
    );
}

export default AddInvoicePdfFormat;
